import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/lib/stores/authStore';
import { AnkhSpinner } from '@/components/common/AnkhSpinner';

export default function AuthLayout() {
  const { isLoggedIn, isLoading, hasHydrated } = useAuthStore();

  // One-shot post-auth destination. Guest start sets '/lobby' so a brand-new
  // player lands in the lobby, not the dashboard, even when this logged-in
  // bounce wins the race after anonymous sign-in. The flag is READ (not mutated)
  // during render; the removal lives in an effect so render stays pure under
  // StrictMode's double-invoke (mutating here would clear it on the first pass
  // and route the second pass to /dashboard).
  const ready = hasHydrated && !isLoading;
  const redirectTarget =
    ready && isLoggedIn ? sessionStorage.getItem('post-auth-redirect') || '/dashboard' : null;
  useEffect(() => {
    if (redirectTarget) sessionStorage.removeItem('post-auth-redirect');
  }, [redirectTarget]);

  if (!ready) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <AnkhSpinner size="lg" className="text-accent-gold" />
      </div>
    );
  }

  if (isLoggedIn) {
    return <Navigate to={redirectTarget ?? '/dashboard'} replace />;
  }

  return (
    <div className="flex-1 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-xl w-full space-y-8">
        <Outlet />
      </div>
    </div>
  );
}
